import { Monitor, Moon, Sun1 } from '@/components/icons';
import {
    DropdownMenuLabel,
    DropdownMenuRadioGroup,
    DropdownMenuRadioItem,
} from '@/components/ui/dropdown-menu';
import { useTheme, type Theme } from '@/context/ThemeContext';

const THEME_OPTIONS: { value: Theme; label: string; Icon: typeof Sun1 }[] = [
    { value: 'light', label: 'Claro', Icon: Sun1 },
    { value: 'dark', label: 'Escuro', Icon: Moon },
    { value: 'system', label: 'Sistema', Icon: Monitor },
];

/**
 * The Light / Dark / System radio items. Render inside an existing
 * `DropdownMenuContent` (e.g. the sidebar settings menu).
 */
export const ThemeMenuItems = () => {
    const { theme, setTheme } = useTheme();

    return (
        <>
            <DropdownMenuLabel>Tema</DropdownMenuLabel>
            <DropdownMenuRadioGroup
                value={theme}
                onValueChange={(value: string) => setTheme(value as Theme)}
            >
                {THEME_OPTIONS.map(({ value, label, Icon }) => (
                    <DropdownMenuRadioItem key={value} value={value} className="cursor-pointer">
                        <Icon className="mr-2 size-4" />
                        {label}
                    </DropdownMenuRadioItem>
                ))}
            </DropdownMenuRadioGroup>
        </>
    );
};
